// extracted by mini-css-extract-plugin
module.exports = {"queue":"EmployeesQueue_queue__fnL4M","items":"EmployeesQueue_items__4PMjF","photo":"EmployeesQueue_photo__mljNJ"};